import { css, styled } from '../../core';
import Panel from '../../panel';
export const PickerPanel = styled(Panel) `
  display: flex;
  flex-direction: column;
  padding: 0px;
  position: absolute;
  z-index: 999;
  ${p => (p.popupPosition === 'right' ? 'right: 0;' : 'left: 0;')}
  ${p => p.showPopupBelow
    ? css `
          margin-top: 50px;
          top: 0;
        `
    : css `
          bottom: 0;
          margin-bottom: 50px;
        `}
`;
